import React from "react";

import * as SC from "./CampaignStatus.styled";
import DarkSelect from "../../../../../Components/DarkSelect/DarkSelect";
import { listOfStatus } from "../../../../../utils/Helpers";
import { useTranslation } from "react-i18next";

const CampaignStatus = ({ status }) => {
  const { t } = useTranslation();
  if (!status) return null;

  const options = listOfStatus(t).map((status) => {
    return { value: status.value, label: status.name, color: status.styles.background };
  });

  const selectedStatus = options.find((option) => option.value === status);

  return (
    <SC.Wrapper>
      <DarkSelect options={options} value={selectedStatus} />
    </SC.Wrapper>
  );
};

export default CampaignStatus;
